// @ts-nocheck
import * as Types from '../__generated__/graphqlTypes';

import { gql } from '@apollo/client';
export type SummaryUtils_CheckoutConfigOptionGroupFragment = { __typename?: 'CheckoutConfigOptionGroup', id: string, step: Types.CheckoutConfigOptionGroupStep, isEnabled: boolean, interiorSubStep?: { __typename?: 'CheckoutConfigInteriorSubStep', id: string, displayName: string, stepNumber: number } | null | undefined, group: { __typename?: 'ReadyPlanOptionGroup', id: string, name: string, location?: { __typename?: 'Location', id: string, name: string } | null | undefined }, options: Array<{ __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } }>, selectedOption?: { __typename?: 'CheckoutConfigPotentialOption', id: string, totalPriceInCents: number, option: { __typename?: 'ReadyPlanOption', id: string, name: string, code: string } } | null | undefined };

export const SummaryUtils_CheckoutConfigOptionGroupFragmentDoc = gql`
    fragment SummaryUtils_CheckoutConfigOptionGroup on CheckoutConfigOptionGroup {
  id
  step
  isEnabled
  interiorSubStep {
    id
    displayName
    stepNumber
  }
  group {
    id
    name
    location {
      id
      name
    }
  }
  options {
    id
    totalPriceInCents
    option {
      id
      name
      code
    }
  }
  selectedOption {
    id
    totalPriceInCents
    option {
      id
      name
      code
    }
  }
}
    `;